import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SendUsAMessage() {
  const serviceAreas = ["Dublin City Centre", "South Dublin (D4, D6, D14)", "North Dublin", "Dun Laoghaire & Rathdown"];
  return <section data-section-id="221884" id="send-us-a-message" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center max-w-6xl mx-auto">
          
          <div className="space-y-10">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-bold font-default text-primary tracking-tight">
                Get in Touch
              </h2>
              <p className="text-lg text-muted-foreground font-sans max-w-md">
                Need a professional plumber or heating engineer in Dublin? Contact D4 Plumbing & Heating for a free, no-obligation quote today.
              </p>
            </div>

            <div className="space-y-8">
              <div className="flex items-start gap-5">
                <div className="p-3 bg-primary/10 rounded-lg shrink-0">
                  <Phone className="w-7 h-7 text-primary" strokeWidth={2} />
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-medium text-muted-foreground font-mono uppercase tracking-wider">
                    Call or WhatsApp
                  </p>
                  <div className="space-y-1">
                    <div>
                      <a href="tel:+35319081819" className="text-xl md:text-2xl font-bold text-foreground font-default hover:text-primary transition-colors inline-block">
                        Office 01 908 1819
                      </a>
                    </div>
                    <div>
                      <Link to="https://wa.me/353857063869" newTab className="text-xl md:text-2xl font-bold text-foreground font-default hover:text-primary transition-colors inline-block">
                        Mobile / WhatsApp 085 706 3869
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-5">
                <div className="p-3 bg-primary/10 rounded-lg shrink-0">
                  <Mail className="w-7 h-7 text-primary" strokeWidth={2} />
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-medium text-muted-foreground font-mono uppercase tracking-wider">
                    Email Us
                  </p>
                  <p className="text-2xl md:text-3xl font-bold text-foreground font-default">
                    <a href="mailto:info@d4gas.ie" className="hover:text-primary transition-colors">
                      info@d4gas.ie
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-4">
              <Button size="lg" asChild className="text-base h-12 px-8 bg-primary hover:bg-primary/90 text-primary-foreground shadow-md rounded-md">
                <Link to="/ContactPage">Request a Free Quote</Link>
              </Button>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden bg-card border border-border shadow-xl p-8 md:p-12 h-full min-h-[400px] flex flex-col justify-center">
            <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/dublin_service_map_overlay.png)] bg-cover bg-center opacity-5 mix-blend-multiply pointer-events-none"></div>
            
            <div className="relative z-10">
              <div className="inline-flex items-center gap-3 mb-8 bg-background/80 backdrop-blur-md px-4 py-2 rounded-lg border border-border shadow-sm">
                <MapPin className="w-5 h-5 text-ring" />
                <h3 className="text-xl font-bold font-default text-foreground">
                  Areas Covered
                </h3>
              </div>
              
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {serviceAreas.map((area, i) => <li key={i} data-index={i} className="flex items-center gap-4 bg-background/40 backdrop-blur-sm p-4 rounded-lg border border-border/50 hover:border-ring/50 transition-all shadow-sm">
                    <div className="w-3 h-3 rounded-md bg-ring" />
                    <span className="text-lg font-semibold text-foreground font-default">
                      {area}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

        </div>
      </div>
    </section>;
}